import { render, staticRenderFns } from "./PresentContents.vue?vue&type=template&id=5ada8964&scoped=true&"
import script from "./PresentContents.vue?vue&type=script&lang=js&"
export * from "./PresentContents.vue?vue&type=script&lang=js&"
import style0 from "./PresentContents.vue?vue&type=style&index=0&id=5ada8964&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ada8964",
  null
  
)

export default component.exports